import { render, staticRenderFns } from "./Iso.vue?vue&type=template&id=90735a88&scoped=true&"
import script from "./Iso.vue?vue&type=script&lang=js&"
export * from "./Iso.vue?vue&type=script&lang=js&"
import style0 from "./Iso.vue?vue&type=style&index=0&id=90735a88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90735a88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VImg,VRow})
